import * as tslib_1 from "tslib";
import HeaderCharm from './HeaderCharm';
import { observer } from 'mobx-react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { lazyUpdateIsGlimpseOpen, SkypeGlimpse, skypeStore, lazyShouldShowUnreadConversationCount, } from 'owa-skype';
var SkypeCharm = /** @class */ (function (_super) {
    tslib_1.__extends(SkypeCharm, _super);
    function SkypeCharm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setCharmDiv = function (headerCharm) {
            _this.charmDiv = ReactDOM.findDOMNode(headerCharm);
        };
        _this.onDismiss = function () {
            lazyUpdateIsGlimpseOpen.importAndExecute(false);
        };
        return _this;
    }
    SkypeCharm.prototype.render = function () {
        var isOpen = skypeStore.isGlimpseOpen;
        var isBusiness = isControlFeatureEnabled('fwk-skypeBusiness');
        var icon = isBusiness ? "OfficeChat" /* OfficeChat */ : "SkypeLogo" /* SkypeLogo */;
        var label = isBusiness
            ? strings.skypeEnterpriseCharm_ariaLabel
            : strings.skypeCharm_ariaLabel;
        var labelWithBadgeCount = isBusiness
            ? strings.skypeEnterpiseCharmBadgeCount_ariaLabel
            : strings.skypeCharmBadgeCount_ariaLabel;
        return (skypeStore.isSwcInitialized && (React.createElement(HeaderCharm, { ref: this.setCharmDiv, key: "skype", icons: {
                iconName: icon,
                hoverIconName: icon,
            }, title: label, ariaLabel: label, ariaLabelWithBadgeCount: labelWithBadgeCount, behavior: {
                isActive: isOpen,
                content: this.renderCharmContent(isOpen),
                onClick: function () {
                    lazyUpdateIsGlimpseOpen.importAndExecute(!isOpen);
                },
            }, getBadgeCount: function () {
                return lazyShouldShowUnreadConversationCount.tryImportSync()
                    ? skypeStore.unreadConversationCount
                    : null;
            } })));
    };
    SkypeCharm.prototype.renderCharmContent = function (isGlimpseOpen) {
        return isGlimpseOpen && React.createElement(SkypeGlimpse, { onDismiss: this.onDismiss, target: this.charmDiv });
    };
    SkypeCharm = tslib_1.__decorate([
        observer
    ], SkypeCharm);
    return SkypeCharm;
}(React.Component));
export default SkypeCharm;
//# sourceMappingURL=SkypeCharm.js.map